import { Route, Routes } from 'react-router-dom'

import { FunctionComponent } from 'react'
import RequestResetPassword from 'src/authentication/request-reset-password'
import ResetPassword from 'src/authentication/reset-password'
import RegisterPage from 'src/user/register'
import StripeCheckoutPage from 'src/stripe-checkout/stripe-checkout-page'
import ThankYouPage from 'src/stripe-checkout/thank-you'
import RegisterUser from './user/register-user.page'

/* v3 */
import PrivateRoute from './private-route'
import Unauthenticated from './components/unauthenticated'
import UnauthenticatedLayout from './layouts/unauthenticated-layout'
import Error404Page from './components/404-page'
import SelfPacedLayout from './v3/self-paced/layout'
import SelfPacedHome from './v3/self-paced'
import SelfPacedSearch from './v3/self-paced/search'
import ContinueWatching from './v3/self-paced/continue-watching'
import SelfPacedAssignments from './v3/self-paced/assignments'
import SelfPacedSection from './v3/self-paced/section'
import SelfPacedCourse from './v3/self-paced/course'
import SelfPacedSeries from './v3/self-paced/series'
import ClassroomPage from './v3/classroom'
import ClassroomSurveyPage from './v3/classroom/survey'
import ClassroomCertificatePage from './v3/classroom/certificate'
import AdminLayout from './v3/admin/layout'
import AdminDashboard from './v3/admin/dashboard'
import UserAdministration from './v3/admin/users'
import LinkedServices from './v3/admin/linked-services'
import AdminSpecialCertifications from './v3/admin/special-certifications'
import AdminLiveClasses from './v3/admin/live'
import AdminLiveClass from './v3/admin/live/class'
import AdminLiveClassTemplates from './v3/admin/live/templates'
import CreateLayout from './v3/create/layout'
import CreatePage from './v3/create'
import CreateSectionPage from './v3/create/section'
import CreateCoursePage from './v3/create/course'
import CreateClassPage from './v3/create/class'
import CreateAccreditationPage from './v3/create/accreditation'
import CreateTemplatePage from './v3/create/template'
import CreateLearningPathPage from './v3/create/learning-path'
import CreateTitleScreenPage from './v3/create/title-screen'
import CreateVideosPage from './v3/create/videos'
import VideoDetailPage from './v3/create/videos/video'
import CreateTextContentPage from './v3/create/text-content'
import CreateQuizPage from './v3/create/quiz'
import CreateStoryboardPage from './v3/create/storyboard'
import SeriesPage from './v3/create/series'
import CreateV4Layout from './v3/create/v4/layout'
import CreateV4Landing from './v3/create/v4'
import CourseWizard from './v3/create/v4/course'
import ClassWizard from './v3/create/v4/class'
import CreateV4Templates from './v3/create/v4/templates'
import CreateV4LearningPaths from './v3/create/v4/learning-paths'
import CreateV4Series from './v3/create/v4/series'
import ManageLayout from './v3/manage/layout'
import ManageDashboard from './v3/manage/dashboard'
import CEAnalytics from './v3/manage/analytics/ce'
import ManageLinkedService from './v3/manage/linked-service'
import ManageAssignments from './v3/manage/assignments'
import ManageAssignment from './v3/manage/assignments/assignment'
import ManageCreateAssignment from './v3/manage/assignments/create'
import ManageTrainingSeries from './v3/manage/assignments/training-series'
import ManageSingleTrainingSeries from './v3/manage/assignments/training-series/training-series'
import ManageCreateTrainingSeries from './v3/manage/assignments/training-series/create'
import ManageGroups from './v3/manage/groups'
import ManageGroupV3 from './v3/manage/groups/group'
import ManageCreateGroup from './v3/manage/groups/create'
import ManageRoster from './v3/manage/roster'
import ManageUser from './v3/manage/roster/member'
import LiveLayout from './v3/live/layout'
import LivePage from './v3/live'
import SessionPage from './v3/live/session'
import LiveSurveyPage from './v3/live/survey'
import LiveCertificatePage from './v3/live/certificate'
import EventsLayout from './v3/events/layout'
import EventsPage from './v3/events'
import EventEditPage from './v3/events/event-edit'
import EventViewPage from './v3/events/event-view'
import EventQuiz from './v3/events/take-quiz'
import EventCertificate from './v3/events/certificate'
import CreateEventPage from './v3/events/create'
import ProfileLayout from './v3/profile/layout'
import ProfileDashboard from './v3/profile/index'
import ProfileAssignments from './v3/profile/assignments'
import ProfileCertificates from './v3/profile/certificates'
import ProfileCredentials from './v3/profile/credentials'
import ProfileLearningPaths from './v3/profile/learning-paths'
import ProfileNewYorkLearningPaths from './v3/profile/new-york-learning-paths'
import ProfileLinkedServices from './v3/profile/linked-services'
import ProfileIBSC100Renewal from './v3/profile/ibsc-100'
import ProfileIBSC40Renewal from './v3/profile/ibsc-40'
import ScribeLayout from './v3/scribe/layout'
import ScribeAccreditationReporting from './v3/scribe'
import ScribeCAPCEAnalytics from './v3/scribe/capce-submission-report'
import BoundTreeRegister from './user/bound-tree-register'
import BoundTreeTrialRegister from './user/bound-tree-trial'
import BoundTreeLogin from './user/bound-tree-login'
import AuthLoginReport from './v3/scribe/auth-login-report'
import UserDemographics from './v3/scribe/user-demographics'

let App: FunctionComponent = () => (
  <Routes>
    <Route path="/register" element={<RegisterPage />} />
    <Route
      path="/boundtree"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Register">
          <BoundTreeRegister />
        </UnauthenticatedLayout>
      }
    />
    <Route
      path="/boundtree-trial"
      element={
        <UnauthenticatedLayout
          requireAuth={true}
          title="Register for Free Trial"
        >
          <BoundTreeTrialRegister />
        </UnauthenticatedLayout>
      }
    />

    <Route
      path="/subscribe-boundtree"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Subscribe">
          <StripeCheckoutPage isBoundtree={true} />
        </UnauthenticatedLayout>
      }
    />

    <Route
      path="/boundtree-login"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Login">
          <BoundTreeLogin />
        </UnauthenticatedLayout>
      }
    />
    <Route
      path="/complete-registration"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Complete Registration">
          <RegisterUser />
        </UnauthenticatedLayout>
      }
    />
    <Route path="/" element={<Unauthenticated />} />
    <Route
      path="/request-reset-password"
      element={
        <UnauthenticatedLayout
          requireAuth={true}
          title="Request Password Reset"
        >
          <RequestResetPassword />
        </UnauthenticatedLayout>
      }
    />
    <Route
      path="/reset-password"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Reset Password">
          <ResetPassword />
        </UnauthenticatedLayout>
      }
    />
    <Route
      path="/subscribe"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Subscribe">
          <StripeCheckoutPage isBoundtree={false} />
        </UnauthenticatedLayout>
      }
    />
    <Route
      path="/thank-you"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Thank You!">
          <ThankYouPage />
        </UnauthenticatedLayout>
      }
    />

    {/* V3 Routes */}
    <Route
      path="/self-paced"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedHome />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/search"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedSearch />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/self-paced/continue-watching"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <ContinueWatching />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/self-paced/assignments"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedAssignments />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/self-paced/section/:sectionId"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedSection />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/self-paced/course/:courseId"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedCourse />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/self-paced/series/:seriesID"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedSeries />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/classroom/:courseID/:classID"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <ClassroomPage />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/classroom/survey/:courseID/:classID"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <ClassroomSurveyPage />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/classroom/certificate/:surveyID/:courseID/:classID"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <ClassroomCertificatePage />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/live"
      element={
        <PrivateRoute
          element={
            <LiveLayout>
              <LivePage />
            </LiveLayout>
          }
        />
      }
    />
    <Route
      path="/live/session/:sessionID"
      element={
        <PrivateRoute
          element={
            <LiveLayout>
              <SessionPage />
            </LiveLayout>
          }
        />
      }
    />
    <Route
      path="/live/survey/:quizID"
      element={
        <PrivateRoute
          element={
            <LiveLayout>
              <LiveSurveyPage />
            </LiveLayout>
          }
        />
      }
    />
    <Route
      path="/live/certificate/:surveyID"
      element={
        <PrivateRoute
          element={
            <LiveLayout>
              <LiveCertificatePage />
            </LiveLayout>
          }
        />
      }
    />
    <Route
      path="/events"
      element={
        <PrivateRoute
          element={
            <EventsLayout>
              <EventsPage />
            </EventsLayout>
          }
        />
      }
    />
    <Route
      path="/events/create"
      element={
        <PrivateRoute
          element={
            <EventsLayout>
              <CreateEventPage />
            </EventsLayout>
          }
        />
      }
    />
    <Route
      path="/events/:eventId"
      element={
        <PrivateRoute
          element={
            <EventsLayout>
              <EventViewPage />
            </EventsLayout>
          }
        />
      }
    />
    <Route
      path="/events/:eventId/edit"
      element={
        <PrivateRoute
          element={
            <EventsLayout>
              <EventEditPage />
            </EventsLayout>
          }
        />
      }
    />
    <Route
      path="/events/:eventId/quiz"
      element={
        <PrivateRoute
          element={
            <EventsLayout>
              <EventQuiz />
            </EventsLayout>
          }
        />
      }
    />
    <Route
      path="/events/:eventId/certificate"
      element={
        <PrivateRoute
          element={
            <EventsLayout>
              <EventCertificate />
            </EventsLayout>
          }
        />
      }
    />
    <Route
      path="/admin"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <AdminDashboard />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/users"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <UserAdministration />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/linked-services"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <LinkedServices />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/special-certifications"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <AdminSpecialCertifications />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/live"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <AdminLiveClasses />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/live/templates"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <AdminLiveClassTemplates />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/live/class/:liveClassID"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <AdminLiveClass />
            </AdminLayout>
          }
        />
      }
    />

    <Route
      path="/create"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreatePage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/section"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateSectionPage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/course"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateCoursePage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/class"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateClassPage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/accreditation"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateAccreditationPage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/template"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateTemplatePage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/learning-path"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateLearningPathPage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/title-screen"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateTitleScreenPage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/videos"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateVideosPage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/videos/video/:id"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <VideoDetailPage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/text-content"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateTextContentPage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/quiz"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateQuizPage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/storyboard"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <CreateStoryboardPage />
            </CreateLayout>
          }
        />
      }
    />
    <Route
      path="/create/series"
      element={
        <PrivateRoute
          element={
            <CreateLayout>
              <SeriesPage />
            </CreateLayout>
          }
        />
      }
    />

    {/* V4 Create Routes */}
    <Route
      path="/create/v4"
      element={
        <PrivateRoute
          element={
            <CreateV4Layout>
              <CreateV4Landing />
            </CreateV4Layout>
          }
        />
      }
    />
    <Route
      path="/create/v4/course"
      element={
        <PrivateRoute
          element={
            <CreateV4Layout>
              <CourseWizard />
            </CreateV4Layout>
          }
        />
      }
    />
    <Route
      path="/create/v4/course/:courseId"
      element={
        <PrivateRoute
          element={
            <CreateV4Layout>
              <CourseWizard />
            </CreateV4Layout>
          }
        />
      }
    />
    <Route
      path="/create/v4/class"
      element={
        <PrivateRoute
          element={
            <CreateV4Layout>
              <ClassWizard />
            </CreateV4Layout>
          }
        />
      }
    />
    <Route
      path="/create/v4/class/:classId"
      element={
        <PrivateRoute
          element={
            <CreateV4Layout>
              <ClassWizard />
            </CreateV4Layout>
          }
        />
      }
    />
    {/* Nested Class Wizard Routes */}
    <Route
      path="/create/v4/course/:courseId/class"
      element={
        <PrivateRoute
          element={
            <CreateV4Layout>
              <ClassWizard />
            </CreateV4Layout>
          }
        />
      }
    />
    <Route
      path="/create/v4/course/:courseId/class/:classId"
      element={
        <PrivateRoute
          element={
            <CreateV4Layout>
              <ClassWizard />
            </CreateV4Layout>
          }
        />
      }
    />
    <Route
      path="/create/v4/templates"
      element={
        <PrivateRoute
          element={
            <CreateV4Layout>
              <CreateV4Templates />
            </CreateV4Layout>
          }
        />
      }
    />
    <Route
      path="/create/v4/learning-paths"
      element={
        <PrivateRoute
          element={
            <CreateV4Layout>
              <CreateV4LearningPaths />
            </CreateV4Layout>
          }
        />
      }
    />
    <Route
      path="/create/v4/series"
      element={
        <PrivateRoute
          element={
            <CreateV4Layout>
              <CreateV4Series />
            </CreateV4Layout>
          }
        />
      }
    />

    <Route
      path="/manage"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageDashboard />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/analytics/ce"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <CEAnalytics />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/linked-service"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageLinkedService />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/roster"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageRoster />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/roster/:userId"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageUser />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageAssignments />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/:assignmentId"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageAssignment />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/create"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageCreateAssignment />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/training-series"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageTrainingSeries />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/training-series/:trainingSeriesId"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageSingleTrainingSeries />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/training-series/create"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageCreateTrainingSeries />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/groups"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageGroups />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/groups/:groupId"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageGroupV3 />
            </ManageLayout>
          }
        />
      }
    />
    <Route
      path="/manage/groups/create"
      element={
        <PrivateRoute
          element={
            <ManageLayout>
              <ManageCreateGroup />
            </ManageLayout>
          }
        />
      }
    />

    <Route
      path="/profile"
      element={
        <PrivateRoute
          element={
            <ProfileLayout>
              <ProfileDashboard />
            </ProfileLayout>
          }
        />
      }
    />
    <Route
      path="/profile/assignments"
      element={
        <PrivateRoute
          element={
            <ProfileLayout>
              <ProfileAssignments />
            </ProfileLayout>
          }
        />
      }
    />
    <Route
      path="/profile/certificates"
      element={
        <PrivateRoute
          element={
            <ProfileLayout>
              <ProfileCertificates />
            </ProfileLayout>
          }
        />
      }
    />
    <Route
      path="/profile/credentials"
      element={
        <PrivateRoute
          element={
            <ProfileLayout>
              <ProfileCredentials />
            </ProfileLayout>
          }
        />
      }
    />
    <Route
      path="/profile/learning-paths"
      element={
        <PrivateRoute
          element={
            <ProfileLayout>
              <ProfileLearningPaths />
            </ProfileLayout>
          }
        />
      }
    />
    <Route
      path="/profile/new-york-learning-paths"
      element={
        <PrivateRoute
          element={
            <ProfileLayout>
              <ProfileNewYorkLearningPaths />
            </ProfileLayout>
          }
        />
      }
    />
    <Route
      path="/profile/linked-services"
      element={
        <PrivateRoute
          element={
            <ProfileLayout>
              <ProfileLinkedServices />
            </ProfileLayout>
          }
        />
      }
    />
    <Route
      path="/profile/ibsc-100"
      element={
        <PrivateRoute
          element={
            <ProfileLayout>
              <ProfileIBSC100Renewal />
            </ProfileLayout>
          }
        />
      }
    />
    <Route
      path="/profile/ibsc-40"
      element={
        <PrivateRoute
          element={
            <ProfileLayout>
              <ProfileIBSC40Renewal />
            </ProfileLayout>
          }
        />
      }
    />
    <Route
      path="/scribe/sentiment-analysis"
      element={
        <PrivateRoute
          element={
            <ScribeLayout>
              <ScribeAccreditationReporting />
            </ScribeLayout>
          }
        />
      }
    />
    <Route
      path="/scribe/capce-submission-report"
      element={
        <PrivateRoute
          element={
            <ScribeLayout>
              <ScribeCAPCEAnalytics />
            </ScribeLayout>
          }
        />
      }
    />
    <Route
      path="/scribe/auth-login-report"
      element={
        <PrivateRoute
          element={
            <ScribeLayout>
              <AuthLoginReport />
            </ScribeLayout>
          }
        />
      }
    />
    <Route
      path="/scribe"
      element={
        <PrivateRoute
          element={
            <ScribeLayout>
              <UserDemographics />
            </ScribeLayout>
          }
        />
      }
    />
    <Route
      path="/*"
      element={
        <UnauthenticatedLayout title="Page Not Found">
          <Error404Page />
        </UnauthenticatedLayout>
      }
    />
  </Routes>
)

export default App
